import { Link } from 'react-router-dom';
import { products } from '../../../mocks/products';
import { useCart } from '../../../context/CartContext';
import { useState } from 'react';

export default function FeaturedSection() {
  const { addItem } = useCart();
  const [added, setAdded] = useState<number | null>(null);
  const featured = products.slice(0, 4);

  const handleAdd = (product: typeof products[0]) => {
    addItem({
      id: product.id,
      name: product.name,
      price: product.price,
      image: product.image,
      category: product.category,
      size: product.size,
    });
    setAdded(product.id);
    setTimeout(() => setAdded(null), 1500);
  };

  return (
    <section className="py-20" style={{ backgroundColor: '#FAFAFA' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="text-brand-purple text-xs font-600 uppercase tracking-widest" style={{ fontWeight: 600 }}>Most popular</span>
            <h2
              className="text-3xl font-700 text-gray-800 mt-1"
              style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}
            >
              Featured Products
            </h2>
          </div>
          <Link
            to="/products"
            className="hidden md:inline-flex items-center gap-2 text-sm font-600 text-brand-yellow hover:text-brand-yellow-dark cursor-pointer whitespace-nowrap"
            style={{ fontWeight: 600 }}
          >
            View all <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {featured.map(product => (
            <div key={product.id} className="bg-white rounded-2xl overflow-hidden hover:scale-105 transition-transform duration-200 group">
              <div className="relative overflow-hidden" style={{ height: '220px' }}>
                <img
                  src={product.image}
                  alt={product.name}
                  title={`${product.name} - second hand kids clothing`}
                  className="w-full h-full object-cover object-top"
                />
                {product.badge && (
                  <span className="absolute top-3 left-3 bg-brand-yellow text-white text-xs font-600 px-2.5 py-1 rounded-full" style={{ fontWeight: 600 }}>
                    {product.badge}
                  </span>
                )}
                <div className="absolute top-3 right-3 bg-white/90 text-xs text-gray-600 px-2.5 py-1 rounded-full font-500" style={{ fontWeight: 500 }}>
                  {product.condition}
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs text-gray-400 mb-1">{product.category} · Size {product.size}</p>
                <h3 className="text-sm font-700 text-gray-800 mb-2 leading-snug" style={{ fontWeight: 700, fontFamily: "'Quicksand', sans-serif" }}>
                  {product.name}
                </h3>
                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-lg font-700 text-brand-yellow" style={{ fontWeight: 700 }}>${product.price.toFixed(2)}</span>
                    <span className="text-xs text-gray-400 line-through ml-2">${product.originalPrice.toFixed(2)}</span>
                  </div>
                  <button
                    onClick={() => handleAdd(product)}
                    className="flex items-center justify-center w-9 h-9 rounded-full cursor-pointer transition-all duration-200 whitespace-nowrap"
                    style={{ backgroundColor: added === product.id ? '#3DBD8A' : '#F5B730' }}
                  >
                    <i className={`text-white text-base ${added === product.id ? 'ri-check-line' : 'ri-add-line'}`}></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 md:hidden">
          <Link
            to="/products"
            className="inline-flex items-center gap-2 text-sm font-600 text-brand-yellow cursor-pointer whitespace-nowrap"
            style={{ fontWeight: 600 }}
          >
            View all products <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
